import React, {useState} from "react";
import {HashRouter, Link, withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import style from './resetAll.scss'
import {actionIcons} from "./schema"
import Modal from 'react-modal'
import fetchWP from './utils/fetchWP';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '25px 45px',
        borderRadius: '12px',
        textAlign: 'center'
    }
};

class ResetAll extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            actionDisabled: false,
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.yesModal = this.yesModal.bind(this);

        this.fetchWP = new fetchWP({
            restURL: window.awcfe_object.root,
            restNonce: window.awcfe_object.api_nonce,
        });

        this.handleResetAll = this.handleResetAll.bind(this);
    }

    openModal() {
        this.setState({modalIsOpen: true, });
    }

    afterOpenModal() {
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    yesModal() {}

    handleResetAll(e) {
        e.preventDefault();

        this.setState({
            actionDisabled: true
        });

        this.fetchWP.post('awcfe_reset_all')
            .then(
                (json) => {
                    this.setState({
                        actionDisabled: false,
                        modalIsOpen: false,
                    });
                    // window.location.reload();
                    window.location.href = json.url;
                    setTimeout(function(){ window.location.reload(); }, 600);
                }
          );

    }

    render() {

        return (<div className={style.wrap}>

                 <span className={style.buttonReset} onClick={() => { this.openModal() }} >
                    {wp.i18n.__('Reset')}
                 </span>

                 <Modal
                     isOpen={this.state.modalIsOpen}
                     onAfterOpen={this.afterOpenModal}
                     onRequestClose={this.closeModal}
                     style = {customStyles}
                     contentLabel="Delete"
                 >
                     <h2 ref={subtitle => this.subtitle = subtitle} > {wp.i18n.__('Are you sure you want to reset?')}</h2>
                     <div className={style.mPopUp} > {wp.i18n.__('This will reset to the default fields.')}<br/> {wp.i18n.__('All your changes will be deleted.')}</div>
                     <button className={style.buttonNo} onClick={this.closeModal}> {wp.i18n.__('Cancel')} </button>
                     <button className={style.buttonYes} onClick={this.handleResetAll} disabled={this.state.actionDisabled} >
                      { this.state.actionDisabled ?
                          <span className={style.buttonLoad}>{wp.i18n.__('Resetting')}</span>
                         : wp.i18n.__('Yes, please reset') }
                     </button>

                     { /* this.state.actionDisabled ?
                       <div className={style.warning_msg}>{wp.i18n.__('Resetting.. Please Wait..')}</div>
                       : '' */ }

                 </Modal>
            </div>)
    }
}


export default ResetAll
